export type LocaleValue = 'de-DE' | 'fr-FR' | 'en';

export type LanguageCode = 'de' | 'fr' | 'en' | 'tu';

export type MarketCode = 'DE' | 'FR';
export const ALLOWED_MARKETS = ['DE', 'FR'];
